import { type KeyboardEvent } from 'react';

type Key =
  | 'space'
  | 'Space'
  | 'enter'
  | 'Enter'
  | 'escape'
  | 'Escape'
  | 'left'
  | 'Left'
  | 'right'
  | 'Right'
  | 'up'
  | 'Up'
  | 'ArrowUp'
  | 'bottom'
  | 'Bottom'
  | 'ArrowDown';

export const keyCodes: Record<Key, number> = {
  enter: 13,
  Enter: 13,
  escape: 27,
  Escape: 27,
  space: 32,
  Space: 32,
  left: 37,
  Left: 37,
  right: 39,
  Right: 39,
  up: 38,
  Up: 38,
  ArrowUp: 38,
  bottom: 40,
  Bottom: 40,
  ArrowDown: 40,
};

export const isKey =
  (...keys: Key[]) =>
  (event: KeyboardEvent): boolean =>
    keys.some(key => event.keyCode === keyCodes[key] || event.code === key);
